import React, { FC } from 'react';
import { Props } from './types';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { IconButton } from '@chakra-ui/react';
import { FAIcon } from './../fa-icon';
import { pickDataAttributes } from '../../utils';
import { i18n } from '../../i18n';

export const InfoTooltip: FC<Props> = ({
  name,
  label,
  buttonClass = '',
  tooltip,
  tooltipPosition = 'left',
  iconTooltip,
  trigger = ['hover', 'focus'],
  ...otherProps
}) => {
  const tooltipClass = iconTooltip && iconTooltip === 'help' ? 'help-tooltip' : 'info-tooltip';
  const iconClass = iconTooltip && iconTooltip === 'help' ? 'circle-question' : 'circle-info';
  const dataAttributes = pickDataAttributes(otherProps, 'info-tooltip');

  // Solution I found in https://github.com/react-bootstrap/react-bootstrap/issues/5166 to fix the positioning of the tooltip
  const tooltipContent = (tooltipProps: object) => (
    <Tooltip id={`tooltip-${name}`} {...tooltipProps}>
      {tooltip}
    </Tooltip>
  );

  return (
    <span className="tooltip-container" {...dataAttributes}>
      <OverlayTrigger placement={tooltipPosition} trigger={trigger} overlay={tooltipContent}>
        <IconButton
          variant="ghost"
          size="2xs"
          m="-1"
          className={`${tooltipClass} ${buttonClass}`}
          aria-label={label ? label : i18n.t('Info')}
        >
          <FAIcon icon={iconClass} style="regular" />
        </IconButton>
      </OverlayTrigger>
    </span>
  );
};
